export function toggleIds(ids, set, setIds) {
  let newIds = [...ids];
  setIds.forEach((id) => {
    if (ids.indexOf(id) >= 0) {
      newIds = ids.filter((i) => i !== id);
    } else {
      newIds.push(id);
    }
  });
  set(newIds);
}

export function toggleValue(val, set, curr) {
  if (val === curr) {
    set('');
  } else {
    set(val);
  }
}
